/*
 *  应用入口
 */
import React from 'react';
import {setLoginParam,setAppMinVersion,setLogoPageInfo,registerLoginMiddleWare} from 'tplus-mobilelogin';
import {registerRoutes, registerStores} from 'mutants-microfx';
import routers from './routers';
// import stores from './store';
import BusLoginStore from './loginMiddleWare/store/LoginStore';
import './styles/index.less';

const appName = 'T+下单';
const appDesc = '';
const serviceDue = true;
const logoSrc = './image/welcome.png'

const indexPage = '';
const username = '17001098120';
const password = '222222';
const accountFilter = ['2019_06','Test131001','2019_07_12_1','130之86号补丁包20190628'];

// const iosVersion = '4.9.0';
// const androidVersion = '4.9.2';

//注册登录中间件
// registerLoginMiddleWare('setSysInfo',BusLoginStore.setSysInfo);
//注册路由
registerRoutes(routers);
//注册store
// registerStores(stores);
//注册登录信息
//setLoginParam({indexPage,username,password,accountFilter,serviceDue});
// //注册app版本控制
// setAppMinVersion({iosVersion, androidVersion });
//工作圈登录欢迎页信息
